/**
 * Minimal reactive store.
 * - Subscribers receive (nextState, prevState) on every setState call.
 * - subscribe() returns an unsubscribe function.
 * - No external dependencies.
 */
export class Store {
  #state;
  #subscribers = new Set();

  constructor(initialState) {
    this.#state = Object.freeze({ ...initialState });
  }

  getState() {
    return this.#state;
  }

  setState(updates) {
    const prev = this.#state;
    this.#state = Object.freeze({ ...prev, ...updates });
    this.#subscribers.forEach(cb => {
      try { cb(this.#state, prev); } catch (e) { console.error('[Store] subscriber error:', e); }
    });
  }

  /** @returns {() => void} unsubscribe */
  subscribe(callback) {
    this.#subscribers.add(callback);
    return () => this.#subscribers.delete(callback);
  }

  reset(initialState) {
    const prev = this.#state;
    this.#state = Object.freeze({ ...initialState });
    this.#subscribers.forEach(cb => {
      try { cb(this.#state, prev); } catch (e) { console.error('[Store] subscriber error:', e); }
    });
  }

  get size() { return this.#subscribers.size; }
}
